import { render, staticRenderFns } from "./adb-image.vue?vue&type=template&id=a3c2606c&"
import script from "./adb-image.vue?vue&type=script&lang=js&"
export * from "./adb-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports